export default {
  contact: {
    description: 'Return a list of my contact information.',
    list: [
      {
        type: 'info',
        label: 'Email:',
        content: '`admin@yaosiqian.cn`'
      },
      {
        type: 'info',
        label: 'Github:',
        content: '`https://github.com/yaosiqian`'
      },
      {
        type: 'info',
        label: 'Bilibili:',
        content: '`https://space.bilibili.com/32539465`'
      }
    ]
  },
  whoami: {
    description: 'Return a piece of code about Qian.',
    list: [
      {
        type: 'success',
        label: 'Done',
        content: 'Qian'
      }
    ]
  }
}
